import React, { useState, forwardRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import {
	FormControl,
	Paper,
	TextField,
	Grid,
	Box,
	Stack,
	FormLabel,
	Typography,
	IconButton,
	Select,
	MenuItem,
} from "@mui/material";

import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";


import Loader from "../../components/Loader";
import BriefForm, {
	defaultBudget,
	defaultFormState,
} from "../../components/BriefForm";
import SuperAdminLayout from "../../layouts/SuperAdminLayout";

import {
	createBrief,
	editBrief,
	getBriefDetailsByBriefIdAPI,
} from "../../apis/briefs.apis";

import { APIerrorMessageHandler } from "../../utils/helper.utils";

import "react-datepicker/dist/react-datepicker.css";

const DateInput = forwardRef(({ value, onClick }, ref) => (
	<TextField value={value} onClick={onClick} ref={ref} />
));

const EditBrief = () => {
	const navigate = useNavigate();
	const { brief_id } = useParams();

	const { data, isLoading, error } = useSWR(
		brief_id ? "briefs/briefs/" + brief_id : null,
		getBriefDetailsByBriefIdAPI.bind(this, brief_id)
	);

	const initialBudgets = data?.budgets?.map((v) => {
		return {
			...v,
			zone: {
				label: v.zone_name,
				id: v.zone_id,
				value: v.zone_id,
			},
			state: {
				label: v.state_name,
				id: v.state_id,
				value: v.state_id,
			},
			city: {
				label: v.city_name,
				id: v.city_id,
				value: v.city_id,
			},
		};
	}) || [defaultBudget];

	const initialFormState = {
		isImmediate: data?.is_immediate_camp || 0,
		startDate: data?.startDate || "",
		endDate: data?.duration || 0,
		specialNotes: data?.notes || "",
		mediaApproach: data?.media_approach || "",
		category: data?.category || "",
		brand: data?.brand_name || "",
		campaign_name: data?.campaign_name || "",
		targetAud: data?.target_audience || "",
		campObj: data?.campaign_obj || "",
		brand_logo: data?.brand_logo || "",
		brandLogo: null,
		brand_logo_url: data?.brand_logo_url || "",
	};

	const handleSubmit = async (fd) => {
		try {
			fd.append("old_image", data.brand_logo);
			await editBrief(data.brief_id, fd);
			toast.success("updated Successfully!");
		} catch (e) {
			APIerrorMessageHandler(e);
		}
	};

	return (
		<SuperAdminLayout activeLink={"/"}>
			<BriefForm
				initialBudgetState={initialBudgets}
				initialFormState={initialFormState}
				onSubmit={handleSubmit}
				submitButtonText="save"
			/>
			<Loader open={isLoading} />
		</SuperAdminLayout>
	);
};

export default EditBrief;
